import AssembleiaItem from "./assembleiaItem.model";
export default class Assembleia {
  id: number;
  tipo: string;
  tipoAssembleia: string;
  modalidadeAssembleia: string;
  inicioVotacao: string;
  data: string;
  fimVotacao: string;
  nomeAta: string;
  ata: string;
  cancelada: boolean;
  emailEnviado: boolean;
  itens: Array<AssembleiaItem>;
  link: string;
  localAssembleia: string;

  expirada: boolean;

  votacaoIniciada: boolean;

  votacaoFinalizada: boolean;
}
